<template>
    <div
        class="CustomTag"
        :class="{ 'CustomTag--filled': filled }"
        :style="{ ...(theme ? { '--custom-tag-base-colour': theme } : {}) }"
    >
        {{ text }}
    </div>
</template>

<script setup lang="ts">
interface CustomTag {
    text: string
    filled?: boolean
    theme?: string
}

const props = withDefaults(defineProps<CustomTag>(), {
    filled: false,
    theme: '',
})
</script>

<style lang="scss" scoped>
.CustomTag {
    color: var(
        --page-theme-base-colour,
        var(--custom-tag-base-colour, var(--lime-green))
    );
    border: 1px solid
        var(
            --page-theme-base-colour,
            var(--custom-tag-base-colour, var(--lime-green))
        );
    padding: 0.625rem;

    @include small-only {
        @include label-sm;
    }

    @media (min-width: 720px) {
        font-size: 0.7rem;
    }

    @include large-up {
        @include label-sm;
    }
}

.CustomTag--filled {
    background-color: var(
        --page-theme-base-colour,
        var(--custom-tag-base-colour, var(--lime-green))
    );
    color: var(--black);
}
</style>
